<template>
  <a-form layout="vertical" ref="formRef" :model="formState" :rules="rules">
    <a-form-item name="url" label="Enlace" required>
      <a-input
        v-model:value="formState.url"
        placeholder="Pega aquí el enlace (https://www.example.com)"
      />
    </a-form-item>

    <a-form-item name="text" label="Texto del botón" required>
      <a-input v-model:value="formState.text" placeholder="Escribir texto" />
    </a-form-item>

    <div class="colors">
      <ColorPicker
        name="backgroundColor"
        label="Color de fondo"
        v-model:color="formState.backgroundColor"
        :required="false"
      />

      <ColorPicker
        name="foregroundColor"
        label="Color de fuente"
        v-model:color="formState.foregroundColor"
        :required="false"
      />
    </div>

    <a-form-item name="alignment" label="Alineación">
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="formState.alignment"
      >
        <a-select-option :value="ItemAlignment.Center">Centro</a-select-option>
        <a-select-option :value="ItemAlignment.Left">Izquierda</a-select-option>
        <a-select-option :value="ItemAlignment.Right">Derecha</a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item name="fullWidth">
      <a-checkbox v-model:checked="formState.fullWidth">Ancho completo</a-checkbox>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { ButtonItem, ItemAlignment } from "@/@types/flows/emailTemplates/items";

import ColorPicker from "@/app/shared/components/pickers/ColorPicker.vue";

const props = defineProps<{ item: ButtonItem }>();

const formRef = ref<FormInstance>();
const formState: Partial<ButtonItem> = reactive({
  alignment: props.item.alignment,
  text: props.item.text,
  backgroundColor: props.item.backgroundColor,
  foregroundColor: props.item.foregroundColor,
  url: props.item.url,
  fullWidth: props.item.fullWidth,
});

const rules = {
  url: [
    {
      pattern: /^https?:\/\/[^\s/$.?#].[^\s]*$/,
      message: "Ingrese una URL válida que comience con https://",
    },
    { required: true, message: "Campo requerido" },
  ],
};

const getValidatedFormState = async () => {
  await formRef.value?.validateFields();

  return formState;
};

defineExpose({ getValidatedFormState });
</script>

<style scoped lang="sass">
.colors
  display: flex
  gap: 40px

  .ant-form-item
    flex: 1 1 auto
    width: 50%
</style>
